import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7bcbc96a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "con" }
const _hoisted_3 = { class: "opinion" }
const _hoisted_4 = { class: "tit" }
const _hoisted_5 = { class: "txt-input" }
const _hoisted_6 = { class: "acts" }

import { Dialog, Toast } from 'vant'
import { ref, onMounted, reactive } from 'vue'
import { useRouter } from 'vue-router'
import { ApproveSave, getApproveType } from '@/apis/approval'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const buttonText = ref('确认同意')
const titleText = ref('')
const router = useRouter()
const state = reactive({
  type: 0,
  item_id: 0,
  state_id: 0
})
const message = ref('')

// 撤销申请
const revoke = () => {
  Dialog.confirm({
    title: titleText.value
  })
    .then(async () => {
      let data = {
        type: state.type,
        item_id: state.item_id,
        state: state.state_id,
        suggest: message.value
      }
      const res = await ApproveSave(data)
      if (res.code === 200) {
        Toast.success({
          message: res.msg,
          duration: 500,
          onClose: () => {
            router.go(-2)
          }
        })
      } else {
        Toast(res.msg)
      }
    })
    .catch(() => {
      Toast('取消操作')
    })
}

const type_name = ref('')

onMounted(() => {
  state.type = Number(router.currentRoute.value.query.typeId)
  state.item_id = Number(router.currentRoute.value.query.itemId)
  state.state_id = Number(router.currentRoute.value.query.state)

  let operate = JSON.parse(localStorage.getItem('operate'))
  type_name.value = operate.map(e => (e.value === state.type ? e.text : null)).join('')
  if (state.state_id == 1) {
    buttonText.value = '确认同意'
    titleText.value = `确认同意“${type_name.value}”吗？`
  }
  if (state.state_id == 2) {
    buttonText.value = '确认拒绝'
    titleText.value = `确认拒绝“${type_name.value}”吗？`
  }
})

return (_ctx: any,_cache: any) => {
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(titleText.value), 1),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_van_field, {
            modelValue: message.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((message).value = $event)),
            rows: "2",
            autosize: "",
            type: "textarea",
            maxlength: "50",
            placeholder: "请输入审批意见",
            "show-word-limit": ""
          }, null, 8, ["modelValue"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_van_button, {
        block: "",
        type: "primary",
        onClick: revoke
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(buttonText.value), 1)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})